import NarrowPhotoAndInfoView from "../NarrowPhotoAndInfoView";
import NarrowInfoView from "../NarrowInfoView";
import useSeasonDetails from "../../hooks/useSeasonDetails";

function DonorGrid({ donors, logoBasePath = "/spendenziel/", skipFirst = false }) {
    const { data } = useSeasonDetails();
    const source = donors || data?.pages?.Spendenziel?.spendenempfaenger?.content || [];
    const visible = source.filter((d) => d.show !== false);
    const items = skipFirst ? visible.slice(1) : visible;

    const rows = items.reduce((acc, item, idx) => {
        if (idx % 2 === 0) acc.push([item]);
        else acc[acc.length - 1].push(item);
        return acc;
    }, []);

    return (
        <div className="space-y-6">
            {rows.map((row, ri) => (
                <div key={ri} className="flex flex-col lg:flex-row mb-8">
                    {row.map((d, ci) => {
                        const title = d.year ? `${d.year}: ${d.recipient || ""}` : d.recipient || "";
                        const paragraphs = d.description ? [d.description] : [];
                        const link = d["show-link"] !== false && d.link ? d.link : undefined;
                        return (
                            <div
                                key={d.year ?? ci}
                                className={`w-full lg:w-1/2 ${ci === 0 ? "lg:pr-4" : "lg:pl-4 mt-4 lg:mt-0"}`}
                            >
                                {d.logo ? (
                                    <NarrowPhotoAndInfoView
                                        title={title}
                                        image={`${logoBasePath}${d.logo}`}
                                        imgPadding={true}
                                        paragraphs={paragraphs}
                                        link={link}
                                    />
                                ) : (
                                    <NarrowInfoView
                                        title={title}
                                        paragraphs={paragraphs}
                                        link={link}
                                    />
                                )}
                            </div>
                        );
                    })}
                </div>
            ))}
        </div>
    );
}

export default DonorGrid;
